module.exports = __webpack_public_path__ + "static/media/1.f8f718c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Intro/assets/1.png
// module id = 116
// module chunks = 0